var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/moral-result-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-52948e90!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/moral-result-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MoralResultList.vue
// module id = 654
// module chunks = 1